import React from 'react'
import { useSelector } from 'react-redux'

import { ClientDetailsSideBar } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/clientDetailsSideBar/ClientDetailsSideBar'

import { RiskBadgeForClient } from '../../../../../common/components/riskBadge/RiskBadgeWithPopover'
import { getAuthConfig } from '../../../../../data/auth/authSelectors'
import { useIsEngageDAProvider } from '../../../../../hooks/useIsEngageDAProvider'
import { useAssignmentsData } from '../../../../assignments/data/hooks/useAssignmentsData'
import { useClientAppointmentsData } from '../../../../clients/clientDetails/data/hooks/useClientAppointmentsData'
import { useSelectedClientData } from '../../../../clients/clientDetails/data/hooks/useSelectedClientData'
import { useEpisodesForSelectedClient } from '../../../../episodes/data/hooks/useEpisodesForSelectedClient'
import useDetailsPanelData from '../../../data/useDetailsPanelData'

const MessengerClientDetailsSideBar: React.FC = () => {
  const { data: selectedClientDetails } = useSelectedClientData()
  const { data: episodes, isLoading: isLoadingEpisodes } = useEpisodesForSelectedClient()
  const { data: appointments } = useClientAppointmentsData()
  const { data: assignments } = useAssignmentsData()
  const isEngageDAProvider = useIsEngageDAProvider()

  const clientDetails = useDetailsPanelData({
    client: selectedClientDetails ?? null,
    episodes,
    isEngageDAProvider,
    appointments,
    assignments,
  })

  const hideRiskAlerts = useSelector(getAuthConfig)?.hideRiskAlerts
  const clientId = selectedClientDetails?.id

  return (
    <ClientDetailsSideBar
      isLoading={isLoadingEpisodes}
      details={clientDetails}
      riskBadgeSlot={
        !hideRiskAlerts && isEngageDAProvider && clientId ? (
          <RiskBadgeForClient
            clientId={clientId}
            logNoteSource='messageCenter'
            showRiskBadge={clientDetails?.client.showRiskBadge}
          />
        ) : undefined
      }
    />
  )
}

export default MessengerClientDetailsSideBar
